export const realEstateFaqs = [
  {
    question: "What is real estate photo editing?",
    answer:
      "Real estate photo editing enhances property photos by adjusting brightness, contrast, white balance, sharpness, and colors. It can also include sky replacement, object removal, window view correction, and virtual staging.",
  },
  {
    question: "Why is photo editing important in real estate?",
    answer:
      "High-quality photos attract more buyers. Edited images help properties stand out online, look more appealing, and sell faster. It also helps maintain a professional and consistent brand.",
  },
  {
    question: "What services do you offer for real estate photos?",
    answer:
      "We provide:\n- Color correction and exposure balance\n- Sky replacement (day-to-dusk)\n- Window view enhancement\n- Object and cable removal\n- Grass greening\n- TV screen and fireplace insertions\n- Virtual staging (optional)\n- HDR blending and manual retouching",
  },
  {
    question: "Can you enhance both interior and exterior shots?",
    answer:
      "Yes, we specialize in both. From brightening dim interiors to enhancing cloudy skies or replacing dead lawns—we make every shot market-ready.",
  },
  {
    question: "Do you support HDR bracketed image blending?",
    answer:
      "Absolutely. Send us your 3–5 bracketed exposures, and we’ll blend them to create a well-balanced final image with great detail in highlights and shadows.",
  },
  {
    question: "What’s the turnaround time?",
    answer:
      "We deliver within:\n- 24 to 36 hours for most standard jobs\n- Larger projects may take 48 hours\nNeed it sooner? Ask for our express service.",
  },
  {
    question: "What file formats do you accept and deliver?",
    answer:
      "You can send us RAW, TIFF, or JPEG files. We deliver high-resolution JPEGs (or any format you prefer) optimized for MLS, web, or print.",
  },
  {
    question: "How do I get started?",
    answer:
      "Simply upload your images, select the services you need, and we’ll handle the rest. Contact us at info@captureedits.com or Request a Free Sample today!",
  },
];
